import type { NativeSelectProps } from '@_/ui';
import type { FormComponentProps } from './types.ts';
import { NativeSelect } from '@_/ui';
import { useFieldContext } from './BaseForm.ts';
import { useMergeHandleChangeAndBlur, usePropsFromField } from './utils.ts';

export function FormNativeSelect(
  props: FormComponentProps<Omit<NativeSelectProps, 'onChange' | 'value'>>
) {
  const field = useFieldContext<string | null>();

  const handleChangeAndBlur = useMergeHandleChangeAndBlur(field.handleChange, field.handleBlur);

  return (
    <NativeSelect
      key={field.name}
      {...usePropsFromField(props, field)}
      onChange={handleChangeAndBlur}
      value={field.state.value}
    />
  );
}
